import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface AuthorMediaLoop {
  id: string;
  user_id: string;
  image_url?: string | null;
  video_url?: string | null;
  thumbnail_url?: string | null;
  content?: string | null;
  created_at: string;
}

export function useAuthorMediaLoops(userId?: string, excludeId?: string, limit: number = 12) {
  const [data, setData] = useState<AuthorMediaLoop[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let isCancelled = false;
    const run = async () => {
      if (!userId) return;
      setLoading(true);
      setError(null);
      try {
        let query = supabase
          .from('loops')
          .select('id,user_id,image_url,video_url,thumbnail_url,content,created_at')
          .eq('user_id', userId)
          .eq('is_active', true)
          .or('image_url.not.is.null,video_url.not.is.null')
          .order('created_at', { ascending: false })
          .limit(limit);
        const { data: rows, error } = await query;
        if (error) throw error as any;
        const filtered = (rows || []).filter(r => r.id !== excludeId);
        if (!isCancelled) setData(filtered);
      } catch (e: any) {
        if (!isCancelled) setError(e);
      } finally {
        if (!isCancelled) setLoading(false);
      }
    };
    run();
    return () => { isCancelled = true; };
  }, [userId, excludeId, limit]);

  return { data, loading, error };
}
